module.exports = __webpack_public_path__ + "img/J13312.ec6c8f5c.png";